import { useState, useEffect } from "react";
//API
import { axiosWithAuth } from "../../../api/axiosConfig";
import {
  urlGetOperaciones2,
  urlGetUninegSaf,
} from "../../../api/URLs/operaciones";
//HOOKS
import { useModal } from "../../../hooks/useModal";
//COMPONENTS
//--Modal
import ModalAlert from "../../../components/Modals/ModalAlert";
//--Table
import Table from "../../../components/Tools/Tables/Table/Table";
//--Basics
import BoxContainer from "../../../components/Tools/Cards/BoxContainer/BoxContainer";
import CenterSpinner from "../../../components/Tools/Basics/Spinner";
import CustomDropdown from "../../../components/Tools/Inputs/CustomDropdown";

const TableDetalleTurnos = () => {
  //useModal
  const { handleError, showModal, modalType, msjModal, handleClose } =
    useModal();
  //States
  const [resumen, setResumen] = useState([]);
  const [puros, setPuros] = useState([]);
  const [mezclas, setMezclas] = useState([]);
  const [uninegs, setUninegs] = useState([]);
  const [selectedUninegs, setSelectedUninegs] = useState([]);
  const [loadingUninegs, setLoadingUninegs] = useState(false);
  const [loading, setLoading] = useState(false);

  //GET
  //antes se mandaba cadena de uninegs por body , se pasaba por parametro en getOperaciones
  const getOperaciones = async (cadena) => {
    try {
      setLoading(true);
      const api_response = await axiosWithAuth.post(urlGetOperaciones2, {
        uninegs: cadena ? cadena : "",
      });
      const data = api_response.data;
      setPuros(data[0]);
      setMezclas(data[1]);
      setResumen(data[2]);
    } catch (error) {
      const auxError = error.response.data.msj
        ? error.response.data.msj
        : "Error del servidor";
      handleError(auxError);
    } finally {
      setLoading(false);
    }
  };
  const getUninegs = async () => {
    try {
      setLoadingUninegs(true);
      const api_response = await axiosWithAuth.get(urlGetUninegSaf);
      const data = api_response.data;
      setUninegs(data);
      const tys = data.find((u) => u.ctrl === 1);
      if (tys && selectedUninegs.length === 0) {
        setSelectedUninegs([tys]);
      }
    } catch (error) {
      const auxError = error.response.data.msj
        ? error.response.data.msj
        : "Error del servidor";
      handleError(auxError);
    } finally {
      setLoadingUninegs(false);
    }
  };
  //COLUMNS PUROS
  const columnsPuros = [
    { header: "Turno", field: "TURNO" },
    { header: "Granel", field: "GRANEL" },
    { header: "Embols.", field: "EMBOLSADO" },
    { header: "Bolson", field: "BOLSON" },
    { header: "Líq.", field: "LIQUIDOS" },
  ];
  //COLUMNS MEZCLAS
  const columnsMezclas = [
    { header: "Turno", field: "TURNO" },
    { header: "Granel", field: "GRANEL" },
    { header: "Embols.", field: "EMBOLSADO" },
    { header: "Bolson", field: "BOLSON" },
    { header: "Líq.", field: "LIQUIDOS" },
  ];
  //COLUMNS RESUMEN
  const columnsResumen = [
    { header: "Turno", field: "TURNO" },
    { header: "Granel", field: "GRANEL" },
    { header: "Embols.", field: "EMBOLSADO" },
    { header: "Bolson", field: "BOLSON" },
    { header: "Líq.", field: "LIQUIDOS" },
  ];
  useEffect(() => {
    getOperaciones();
    getUninegs();
  }, []);

  //con parametro de uninegs
  useEffect(() => {
    // cuando cambian las unidades seleccionadas
    if (selectedUninegs.length > 0) {
      const cadena = selectedUninegs.map((u) => u.ctrl).join(",");
      getOperaciones(cadena); // le pasás las unidades
    }
  }, [selectedUninegs]);

  const handleSelectUnineg = (option) => {
    // Evitar duplicados
    if (!selectedUninegs.find((u) => u.ctrl === option.ctrl)) {
      setSelectedUninegs((prev) => [...prev, option]);
    }
  };

  const handleRemoveUnineg = (ctrl) => {
    if (selectedUninegs.length === 1) return;
    setSelectedUninegs((prev) => prev.filter((u) => u.ctrl !== ctrl));
  };

  if (loading || loadingUninegs) return <CenterSpinner />;
  return (
    <>
      <div className="row">
        <div className="mb-3">
          <CustomDropdown
            options={uninegs}
            onSelect={handleSelectUnineg}
            displayProperty="detalle"
            keyProperty="ctrl"
            btnName="Seleccione una unidad de negocio"
            label="Unidad de Negocio"
          />
          {selectedUninegs.length > 0 && (
            <div className="mb-3 mt-2">
              <div className="d-flex flex-wrap gap-2">
                {selectedUninegs.map((u) => (
                  <div
                    key={u.ctrl}
                    className="d-flex align-items-center bg-light border rounded px-2 py-1"
                  >
                    <span className="me-2">{u.detalle}</span>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => handleRemoveUnineg(u.ctrl)}
                    >
                      ✕
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        <div className="col-md-6">
          <BoxContainer>
            <Table
              data={puros}
              columns={columnsPuros}
              title={"PUROS"}
              keyProp={"PUROS"}
            />
          </BoxContainer>
        </div>
        <div className="col-md-6">
          <BoxContainer>
            <Table
              data={mezclas}
              columns={columnsMezclas}
              title={"MEZCLAS"}
              keyProp={"MEZCLAS"}
            />
          </BoxContainer>
        </div>
        <div className="col-md-6">
          <BoxContainer>
            <Table
              data={resumen}
              columns={columnsResumen}
              title={"RESUMEN"}
              keyProp={"RESUMEN"}
            />
          </BoxContainer>
        </div>
      </div>
      <ModalAlert
        show={showModal}
        type={modalType}
        msj={msjModal}
        handleClose={handleClose}
      />
    </>
  );
};

export default TableDetalleTurnos;
